import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
import { theme } from '../../themes/theme';
export default css `
    ${componentStyles}

    :host {
        display: block;
        cursor: pointer;
    }

    .participant-item {
        padding: var(--sgdf-spacing-small);
        border: 1px solid var(--sgdf-color-light);
        border-radius: var(--sgdf-border-radius-medium);
        overflow: hidden;
    }

    .highlight {
        border-color: var(--sgdf-color-primary-600);
        border-width: 3px;
    }

    .name {
        ${theme.colors.cssColor('text-primary')}
        ${theme.texts.cssBody('bold')}
        overflow: hidden;
        white-space: nowrap;
        position: relative;
        flex-grow: 1;
    }

    .name:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 1em;
        background: linear-gradient(.25turn, rgba(255,255,255,0), #fff);
    }


    .team {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        grid-gap: var(--sgdf-spacing-small);
    }

    .action-icon {
        display: flex;
    }
`;
//# sourceMappingURL=participant-card.styles.js.map